import { render, staticRenderFns } from "./FileDetails.vue?vue&type=template&id=3bc32e4f&scoped=true"
import script from "./FileDetails.vue?vue&type=script&lang=js"
export * from "./FileDetails.vue?vue&type=script&lang=js"
import style0 from "./FileDetails.vue?vue&type=style&index=0&id=3bc32e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc32e4f",
  null
  
)

export default component.exports